import React, { useCallback, useEffect } from 'react'
import { hooks } from '@front/volcanion'

import Callbacks from './callbacks'
import { calculateTimeDelay } from './utils'
import { DialogContent, FormDialog } from '@front/squirtle'
import moment from 'moment'

const withForm = Component => (props) => {
  const { order_id, closeDialogOnComplete = true } = props || {}
  const [{ isOpen }] = hooks.useDialog('simulator')

  const [, { openDialog }] = hooks.useDialogs()
  const [payJob] = hooks.useModelFunction('job', 'pay')
  const [updateStatus] = hooks.useModelFunction('transport', 'updateStatus')
  const [orderCancel] = hooks.useModelFunction('order', 'cancel')
  const [, cancelQueueJob] = hooks.useModelValues('user', 'cancelQueueJob')
  const [, createQueueJob] = hooks.useModelValues('user', 'createQueueJob')
  const [queueJob, getQueueJob] = hooks.useModelValues('user', 'getQueueJob')
  const [auto_redispatch_delay] = hooks.useSetting('auto_redispatch')
  const [dispatch_reminder_delay] = hooks.useSetting('dispatch_reminder')
  const [max_start_planned_order] = hooks.useSetting('max_start_planned_order')

  const [not_loaded_reason_id] = hooks.useModelSearch('reason', 'get', {
    mutator: reason => reason.reason_id,
    initial_filter: {},
    forced_filter: {
      identifier: "not_loaded"
    },
    mode: 'active',
    single: true,
  })

  const [order] = hooks.useModel('order', [order_id], {
    single: true,
    populate: ['quotation', 'driver_estimation', 'payment_type', 'assigned_transport', 'loads', 'job']
  })
  const job_id = order?.job?.job_id

  const [next_transport_status] = hooks.useJobNextStatus({ job_id })
  const estimation = !!order?.payment_type?.bill_passenger ? order?.quotation : order?.driver_estimation
  const driver_package_fee = estimation?.driver_package_fee
  const option_amount = estimation?.option_amount || 0
  const total_delay = calculateTimeDelay(moment.utc(), order?.job?.deferTo, auto_redispatch_delay)

  useEffect(() => {
    !!isOpen && !!job_id && getQueueJob({ name: 'auto_redispatch', job_id })
  }, [isOpen, job_id])

  const onNext = useCallback(
    Callbacks.onNextHandler(openDialog, order, next_transport_status, updateStatus, max_start_planned_order),
    [openDialog, order, next_transport_status, updateStatus, max_start_planned_order]
  )
  const onPayment = useCallback(
    Callbacks.onPaymentHandler(openDialog, order, payJob),
    [openDialog, order, payJob]
  )
  const onCancel = useCallback(
    Callbacks.onCancelHandler(openDialog, order, orderCancel, not_loaded_reason_id),
    [openDialog, order, orderCancel, not_loaded_reason_id]
  )
  const onCancelRedispatch = useCallback(
    Callbacks.onCancelRedispatchHandler(openDialog, order, cancelQueueJob, getQueueJob),
    [openDialog, order, cancelQueueJob, getQueueJob]
  )
  const onEnableRedispatch = useCallback(
    Callbacks.onEnableRedispatchHandler(openDialog, order, createQueueJob, getQueueJob, auto_redispatch_delay, dispatch_reminder_delay),
    [openDialog, order, createQueueJob, getQueueJob, auto_redispatch_delay, dispatch_reminder_delay]
  )
  const onSubmit = useCallback(
    Callbacks.onSubmitHandler(onNext, onPayment, onCancel, onCancelRedispatch, onEnableRedispatch),
    [onNext, onPayment, onCancel, onCancelRedispatch, onEnableRedispatch]
  )
  const getFailedNotification = useCallback(Callbacks.getFailedNotificationHandler(), [])

  const formProps = {
    initialValues: {
      base: 0,
      fees: 0,
      prepaid: 0,
      option_amount,
      driver_package_fee,
    },
    initialState: {
      order_id,
      closeDialogOnComplete,
    },
    onSubmit,
    getFailedNotification,
  }

  const mergedProps = {
    queueJob,
    total_delay
  }


  return (
    <FormDialog
      name='simulator'
      allowConfirm={false}
      closeOnSuccess={false}
      formProps={formProps}
    >
      <DialogContent>
        <Component {...mergedProps} />
      </DialogContent>
    </FormDialog>
  )
}

export default withForm
